import React from 'react';

type ContextSearchProps = {
    searchTerm: string,
    handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
}

export const ContextSearch = ({
  searchTerm,
  handleChange,
}: ContextSearchProps) => {
  return (
    <div className='relative'>
      <span className='pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400'>
        <svg
            xmlns='http://www.w3.org/2000/svg'
            className='h-4 w-4'
            fill='none'
            viewBox='0 0 24 24'
            stroke='currentColor'
        >
          <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
          />
        </svg>
      </span>
      <input
          className='block h-10 w-full rounded-md border border-slate-200 bg-slate-50 py-2 pl-9 pr-3 text-sm leading-5 text-slate-800 shadow-none outline-none transition focus:border-emerald-500 focus:bg-white focus:ring-2 focus:ring-emerald-100'
          type='text'
          placeholder='Search by title, topic, uploader...'
          value={searchTerm}
          onChange={handleChange}
      />
    </div>
  );
};
